import React from "react";
import TableHeadTip from "../TableHeadTip";
import style from "./index.module.scss";
import { Input } from "antd";
import { TextAreaProps } from "antd/lib/input/TextArea";
import { useAtomValue } from "jotai";
import { disabledAtom } from "../../store";
import { useParams } from "react-router-dom";
const { TextArea } = Input;

interface RuleTextProps extends TextAreaProps {}

const Index = ({ ...props }: RuleTextProps) => {
    const { courseNo, courseSeq } = useParams<StringMap>();

    const disabled = useAtomValue(disabledAtom({ courseNo, courseSeq }));

    return (
        <div>
            <TableHeadTip title="考核规则" isShowTips={false} />
            <TextArea
                placeholder="输入课程的考核规则，保存后考核规则对学生可见，不超过500汉字"
                autoSize={{ minRows: 2, maxRows: 5 }}
                className={style.desp}
                disabled={disabled}
                {...props}
                maxLength={500}
            />
        </div>
    );
};

export default Index;
